import axios from "@/axios.js"

export default {
    addItem({commit}, item) {
        return new Promise((resolve, reject) => {
            axios.post("/customer/address/add", item )
                .then((response) => {
                    if(item.id){
                        commit('UPDATE_ADDRESS', Object.assign(item, {id: response.data.id}))
                    }else{
                        commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
                    }
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    fetch({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/customer/order")
                .then((response) => {
                    commit('SET_LIST', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}
